import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/site";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <div className="text-xs font-bold uppercase tracking-[0.22em] text-blue-600">
              What customers say
            </div>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tighter text-slate-900 leading-[1.05]">
              Reviews from neighbors on El Cajon Blvd and beyond.
            </h2>
          </div>
          <div className="flex items-center gap-3 text-slate-700">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="font-display text-2xl font-bold text-slate-900">5.0</span>
            <span className="text-sm text-slate-500">avg. rating</span>
          </div>
        </div>

        <div className="mt-14">
          <Carousel
            opts={{ align: "start", loop: true }}
            data-testid="testimonials-carousel"
          >
            <CarouselContent className="-ml-5">
              {TESTIMONIALS.map((t, idx) => (
                <CarouselItem
                  key={idx}
                  className="pl-5 basis-full sm:basis-1/2 lg:basis-1/3"
                >
                  <article
                    data-testid={`testimonial-${idx}`}
                    className="relative h-full rounded-2xl border border-slate-200 bg-slate-50 p-7 hover:bg-white hover:border-blue-200 hover:shadow-md transition-all"
                  >
                    <Quote className="absolute top-5 right-5 h-7 w-7 text-blue-100" />
                    <div className="flex gap-0.5">
                      {[...Array(t.rating)].map((_, i) => (
                        <Star
                          key={i}
                          className="h-4 w-4 fill-amber-400 text-amber-400"
                        />
                      ))}
                    </div>
                    <p className="mt-5 text-slate-700 leading-relaxed text-[15px]">
                      "{t.text}"
                    </p>
                    <div className="mt-6 pt-5 border-t border-slate-200">
                      <div className="font-display font-semibold text-slate-900">
                        {t.name}
                      </div>
                      <div className="text-xs text-slate-500 uppercase tracking-[0.16em] mt-0.5 font-semibold">
                        {t.role}
                      </div>
                    </div>
                  </article>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="hidden sm:flex justify-end gap-2 mt-8">
              <CarouselPrevious
                data-testid="testimonial-prev"
                className="static translate-y-0 h-11 w-11 rounded-full border-slate-300 hover:bg-slate-100"
              />
              <CarouselNext
                data-testid="testimonial-next"
                className="static translate-y-0 h-11 w-11 rounded-full border-slate-300 hover:bg-slate-100"
              />
            </div>
          </Carousel>
        </div>
      </div>
    </section>
  );
}
